import { Link } from "react-router-dom";
import styled from "styled-components";
import { Container } from "../layout/Container";
import { cPath } from "../../constants";

const Page = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: min(100vh, 52rem);
  background: linear-gradient(
    180deg,
    hsl(${({ theme }) => theme.colors.muted}) 0%,
    hsl(${({ theme }) => theme.colors.background}) 38%,
    hsl(${({ theme }) => theme.colors.muted} / 0.5) 100%
  );
`;

const Hero = styled.div`
  text-align: center;
  padding: clamp(2rem, 5vw, 3.25rem) ${({ theme }) => theme.layout.shellPadX}
    clamp(2.5rem, 6vw, 4rem);
  background: hsl(${({ theme }) => theme.colors.navDark});
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
  border-bottom: 1px solid hsl(${({ theme }) => theme.colors.navDarkForeground} / 0.08);
`;

const BrandLink = styled(Link)`
  display: inline-flex;
  align-items: baseline;
  gap: 0.15rem;
  text-decoration: none;
  font-size: clamp(1.125rem, 1rem + 0.6vw, 1.35rem);
  font-weight: 800;
  letter-spacing: 0.04em;
  margin-bottom: 0.5rem;
`;

const BrandAccent = styled.span`
  color: hsl(${({ theme }) => theme.colors.accent});
`;

const BrandRest = styled.span`
  color: hsl(${({ theme }) => theme.colors.navDarkForeground});
`;

const HeroLead = styled.p`
  margin: 0;
  font-size: clamp(0.875rem, 0.82rem + 0.2vw, 0.9375rem);
  opacity: 0.72;
  max-width: 20rem;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.5;
`;

const CardSection = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  padding: 0 ${({ theme }) => theme.layout.shellPadX} clamp(2rem, 5vw, 3.5rem);
  margin-top: clamp(-2rem, -4vw, -1.25rem);
`;

const Card = styled.div`
  width: 100%;
  max-width: min(100%, ${({ theme }) => theme.layout.formMax});
  background: hsl(${({ theme }) => theme.colors.card});
  border-radius: ${({ theme }) => theme.radius.xl};
  border: 1px solid hsl(${({ theme }) => theme.colors.border});
  box-shadow: ${({ theme }) => theme.shadow.card};
  padding: clamp(1.75rem, 4vw, 2.25rem) clamp(1.25rem, 4vw, 2rem);
`;

const HomeLink = styled(Link)`
  display: block;
  text-align: center;
  margin-top: 1.25rem;
  font-size: 0.8125rem;
  font-weight: 500;
  color: hsl(${({ theme }) => theme.colors.mutedForeground});
  &:hover {
    color: hsl(${({ theme }) => theme.colors.primary});
  }
`;

/**
 * @param {{ heroHint?: string; children: import('react').ReactNode }} props
 */
export default function AuthPageShell({ heroHint, children }) {
  return (
    <Page>
      <Hero>
        <BrandLink to={cPath("")} aria-label="DealBeez home">
          <BrandAccent>DEAL</BrandAccent>
          <BrandRest>BEEZ</BrandRest>
        </BrandLink>
        <HeroLead>
          {heroHint ||
            "Member access — sign in, register, or recover your DealBeez account."}
        </HeroLead>
      </Hero>
      <CardSection>
        <Container style={{ display: "flex", justifyContent: "center" }}>
          <Card>
            {children}
            <HomeLink to={cPath("")}>← Back to home</HomeLink>
          </Card>
        </Container>
      </CardSection>
    </Page>
  );
}
